import { UserOverview } from "./UserOverview";

export const OverView = {
  User: UserOverview
};
